.installments {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--pgm-sys-spacing-3);
    padding-block: var(--pgm-sys-spacing-2);
  }
}

.error {
  color: var(--pgm-sys-color-error);
}
